export default {
    downgrade: '格下げ',
    dropdownSelect: {
        clearSelection: 'すべての選択を解除',
        itemSelected_one: '{{count}}項目が選択済み',
        itemSelected_other: '{{count}}項目が選択済み',
        optionSelected_one: '{{count}}項目が選択済み',
        optionSelected_other: '{{count}}項目が選択済み',
    },
    edit: '編集',
    footer: {
        links: {
            about: 'MakeLeapsについて',
            api: 'API',
            helpCenter: 'ヘルプセンター',
            qAndA: 'Q&A',
            status: 'サービス稼働状況',
        },
    },
    header: {
        freeTrial: '無料トライアル',
        freeTrialEndsIn: '無料トライアル終了まで、あと24日',
        mailpoints: '郵送ポイント',
        menu: {
            billing: '支払情報',
            buyMailPoints: '郵送ポイントを購入する',
            changePlan: 'プランを変更する',
            en: 'English',
            ja: '日本語',
            profile: 'プロフィール',
            signout: 'ログアウト',
        },
        signIn: 'ログイン',
        upgrade: 'アップグレード',
    },
    helpText: {
        building: '例：◯◯◯ビル◯階',
        city: '例：新宿区、大阪市北区',
        neighborhood: '例：西新宿0-0-0',
        phoneNumber: '例：000-0000-0000',
        postcode: '例：000-0000',
        username:
            '半角英数字および記号（. + - _ ）を使用できます。ユーザー名はログイン時に使います。',
    },
    next: '次のページ',
    noResultsFound: '対象が見つかりません',
    password: {
        confirm: 'パスワードの確認',
        input: 'パスワード',
        letter: '半角 英字 1 文字以上',
        min: '長さ 8 文字以上',
        mismatch: 'パスワードが一致しない',
        number: '半角 数字 1 文字以上',
        symbol: '半角 記号 1 文字以上（利用可能：!_+.-,$\'=@;*:"(&)?[^]%~#）',
    },
    pdfMenu: {
        actual: '実際のサイズ',
        automatic: '自動ズーム',
        page: '<0></0>/{{ numPages}}',
    },
    preview: 'プレビュー',
    search: '検索',
    tooltip: {
        close: '閉じる',
        learnMore: '詳細',
    },
    warning: '警告',
};
